// 会员管理
import member from './member.json';

// 数据看板
import dataKanban from './dataKanban.json';

// 系统管理
import setup from './setup.json';

// 营销中心
import market from './market.json';

// 潜在会员
import potential from './potential.json';

// 全部的权限菜单
import allMenuData from './allMenuData.json';

export default {
  member,
  dataKanban,
  setup,
  market,
  potential,
  allMenu: allMenuData
};
